import { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '@/components/core';
import { PROFILE_SOURCES } from '../../../shared/candidate-form-schema';
import { ConditionalOffer } from '../../types/offer.types';

interface CreateOfferTableColumnsProps {
  t: (key: string) => string;
}

const parsePanel = (json: string): { name: string }[] => {
  try {
    return JSON.parse(json) as { name: string }[];
  } catch {
    return [];
  }
};

export const createOfferTableColumns = ({
  t,
}: CreateOfferTableColumnsProps): ColumnDef<ConditionalOffer>[] => [
  {
    // Shows the full name; sorts and filters by first name.
    id: 'FirstName',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('NAME')} />,
    accessorFn: (row) => `${row.FirstName} ${row.LastName}`,
  },
  {
    id: 'Email',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('EMAIL')} />,
    accessorFn: (row) => row.Email,
  },
  {
    id: 'Designation',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('DESIGNATION')} />,
    accessorFn: (row) => row.Designation,
  },
  {
    id: 'InterviewPanel',
    // Names read from InterviewPanelJson; not a field the server can sort on.
    enableSorting: false,
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('INTERVIEW_PANEL')} />,
    accessorFn: (row) =>
      parsePanel(row.InterviewPanelJson)
        .map((member) => member.name)
        .join(', '),
  },
  {
    id: 'Source',
    meta: {
      filter: {
        type: 'options',
        options: PROFILE_SOURCES.map((source) => ({ value: source, label: source })),
      },
    },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('SOURCE')} />,
    accessorFn: (row) => row.Source,
  },
];
